<template>
    <span>
        <b-button
            v-if="value"
            class="align-baseline btn-circle-plus yes-no-button" :class="{'yes-no-editable': params.editable}"
            style="background-color: #CCF1E1"
            size="xs"
        >
            <font-awesome-icon color="#00B76A" :icon="['fas', 'check']"></font-awesome-icon>
        </b-button>
        <b-button
            v-else-if="value == false"
            class="align-baseline btn-circle-minus yes-no-button" :class="{'yes-no-editable': params.editable, 'invisible': invisible}"
            style="background-color: #FFDFDF"
            size="xs"
        >
            <font-awesome-icon color="#FF5E5E" :icon="['fas', 'xmark']"></font-awesome-icon>
        </b-button>        
        <span v-else></span>
    </span>
</template>

<script>
    export default {
        data() {
            return {
                value: false,
            };
        },
        created() {
            this.value = this.params.value;
            this.plain = this.params.plain || false;
            this.invisible = this.params.invisible || false;
        },
    }
</script>

<style lang="scss" scoped>
    :deep(.btn:focus) {
        box-shadow: none !important;        
    }
</style>
